// components/ToggleLivestreamStatusModal.jsx
import React from 'react';
import { FaToggleOn, FaToggleOff, FaTimes } from 'react-icons/fa';

const ToggleLivestreamStatusModal = ({ livestream, onConfirm, onClose, isLoading }) => {
  if (!livestream) return null;
  
  const nuevoEstado = !livestream.habilitado;
  const accion = nuevoEstado ? "habilitar" : "deshabilitar";
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-zinc-800 rounded-lg shadow-xl max-w-md w-full p-6 border border-zinc-700">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold text-white">
            {nuevoEstado ? "Habilitar Livestream" : "Deshabilitar Livestream"}
          </h3>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors"
          >
            <FaTimes />
          </button>
        </div>
        
        <div className="mb-6">
          <div className="flex items-center mb-4">
            <div className="h-16 w-24 rounded overflow-hidden bg-zinc-700 mr-4">
              <img 
                src={livestream.imagen} 
                alt={livestream.titulo}
                className="h-full w-full object-cover"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'https://via.placeholder.com/150x100?text=Sin+Imagen';
                }}
              />
            </div>
            <div>
              <h4 className="text-lg font-medium text-white">{livestream.titulo}</h4>
              <p className="text-sm text-gray-400">
                {livestream.habilitado ? 'Actualmente: Habilitado' : 'Actualmente: Deshabilitado'}
              </p>
              <p className="text-sm text-gray-400">
                Estado: {livestream.estado}
              </p>
            </div>
          </div>
          
          <p className="text-gray-300">
            ¿Estás seguro de que deseas {accion} este livestream? 
            {!nuevoEstado && " Los livestreams deshabilitados no aparecerán en el sitio público."}
          </p>
        </div>
        
        <div className="flex justify-between pt-4 border-t border-zinc-700">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-zinc-700 hover:bg-zinc-600 text-white rounded transition-colors"
            disabled={isLoading}
          >
            Cancelar
          </button>
          <button
            onClick={() => onConfirm(livestream)}
            className={`px-4 py-2 rounded text-white flex items-center ${
              nuevoEstado 
                ? 'bg-green-600 hover:bg-green-700' 
                : 'bg-red-600 hover:bg-red-700'
            } transition-colors`}
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="flex items-center">
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Procesando...
              </span>
            ) : (
              <>
                {nuevoEstado ? <FaToggleOn className="mr-2" /> : <FaToggleOff className="mr-2" />}
                {nuevoEstado ? 'Habilitar' : 'Deshabilitar'}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ToggleLivestreamStatusModal;